import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Chip,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import {
  AddOrUpdateExerciseTagesApi,
  ExerciseTagesApi,
} from "src/DAL/exerciseType/exerciseType";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const ExerciseChips = ({ exercises, setExercises, title }) => {
  const [newExercise, setNewExercise] = useState("");

  const handleDelete = (exerciseToDelete) => {
    if (exercises.length > 1) {
      const updatedExercises = exercises.filter(
        (exercise) => exercise !== exerciseToDelete,
      );
      setExercises(updatedExercises);
    }
  };
  const handleAdd = () => {
    if (newExercise.trim() !== "" && !exercises.includes(newExercise)) {
      setExercises([...exercises, newExercise]);
      setNewExercise("");
    }
  };
  return (
    <>
      <Typography sx={{ mb: 1, fontWeight: 500 }}>{title}</Typography>
      <div className="tages-box ">
        {exercises.map((exercise, index) => (
          <Chip
            sx={{ m: "3px" }}
            key={index}
            label={exercise}
            onDelete={() => handleDelete(exercise)}
            variant="outlined"
          />
        ))}
      </div>
      <div className="row">
        <div className="col-md-3 col-sm-4 mt-2">
          <TextField
            label="New Tag"
            variant="outlined"
            value={newExercise}
            onChange={(e) => setNewExercise(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
        <div className="col-md-9 col-sm-8 h-100 mt-2 ">
          <Button
            sx={{ p: "8px" }}
            variant="contained"
            size="small"
            onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
    </>
  );
};
export default function ExerciseTages() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [exercise, setExercise] = useState([]);
  const [difficulty, setDifficulty] = useState([]);
  const [mainMuscle, setMainMuscle] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let postData = {
      tags: {
        exercise: exercise,
        difficulty: difficulty,
        main_muscle: mainMuscle,
      },
    };
    setIsLoading(true);
    const result = await AddOrUpdateExerciseTagesApi(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const getExerciseTagesListing = async () => {
    setIsLoading(true);
    const result = await ExerciseTagesApi();
    if (result.code === 200) {
      console.log(result, "tages");
      setExercise(result?.tags?.exercise);
      setDifficulty(result?.tags?.difficulty);
      setMainMuscle(result?.tags?.main_muscle);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getExerciseTagesListing();
  }, []);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <h2>Exercies Tags</h2>
          </div>
        </div>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        ></Stack>

        <Card className="mb-2" style={{ overflowX: "auto" }}>
          <div className="p-4">
            <div className="m-1">
              <ExerciseChips
                exercises={exercise}
                setExercises={setExercise}
                title={"Movement Patterns"}
              />
            </div>
          </div>
        </Card>
        <Card className="mb-2" style={{ overflowX: "auto" }}>
          <div className="p-4">
            <div className="m-1">
              <ExerciseChips
                exercises={mainMuscle}
                setExercises={setMainMuscle}
                title={"Muscle"}
              />
            </div>
          </div>
        </Card>
        <Card className="mb-2" style={{ overflowX: "auto" }}>
          <div className="p-4">
            <div className="m-1">
              <ExerciseChips
                exercises={difficulty}
                setExercises={setDifficulty}
                title={"Difficulty"}
              />
            </div>
          </div>
        </Card>
        <div className="text-end mt-4">
          <button onClick={handleSubmit} className="small-contained-button">
            Submit
          </button>
        </div>
      </div>
    </>
  );
}
